import * as React from 'react';
import { useEffect } from 'react';

import { OrderManifestIssueTypeOptions } from './constants';
import { ClaimFormProps } from './types';

export const OrderManifestForm = ({
  formData,
  setFormData,
  setIsValid,
}: Omit<ClaimFormProps, 'product'>) => {
  useEffect(() => {
    const isValidForm = formData.orderManifestIssueType !== undefined;
    setIsValid(isValidForm);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  return (
    <div className="flex flex-col space-y-4">
      <div className="flex flex-col space-y-2">
        <label className="block text-lg font-semibold text-gray-700 mb-1">
          What was the issue with their order manifest?
        </label>
        <div className="space-y-2">
          {OrderManifestIssueTypeOptions.map((option) => (
            <div key={option.value} className="flex items-center space-x-2">
              <input
                id={`order-manifest-${option.value}`}
                type="radio"
                name="order_manifest_issue_type"
                value={option.value}
                checked={formData.orderManifestIssueType === option.value}
                onChange={() =>
                  setFormData({
                    ...formData,
                    orderManifestIssueType: option.value,
                  })
                }
                className="h-4 w-4 text-blue-600"
              />
              <label htmlFor={`order-manifest-${option.value}`} className="cursor-pointer">
                {option.label}
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
